import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators
} from "@angular/forms";
import { Observable, of } from "rxjs";
import { Subject } from "rxjs";

import { DataService } from "./../../data.service";
import { ApplicationViewService } from "./applicationview.service";

@Component({
  selector: "app-applicationview",
  templateUrl: "./applicationview.component.html",
  styleUrls: ["./applicationview.component.scss"]
})
export class ApplicationViewComponent implements OnInit {
  displayedColumns = ["profilename", "accessgranted", "defaultapp"];

  application: {
    name: any;
    label: any;
    description: any;
    standard: any;
    active: any;
    iconname: any;
    baseurl: any;
    sinceversionseq: any;
    deprecatedversionseq: any;
    sortorder: any;
    core: any;
  };
  appSettingsJSON: string | any[];
  fgsArray = new Array<FormGroup>();
  isLoading = false;
  isError = false;
  errorMessage = "";
  applicationId = "";
  appName = "";

  detailForm = this.fb.group({
    name: "",
    label: "",
    description: "",
    logopath: "",
    standard: false,
    active: false,
    iconname: "",
    baseurl: "",
    sinceversionseq: 0,
    deprecatedversionseq: 0,
    sortorder: 0,
    core: false
  });

  profileForm = this.fb.group({
    appsettings: this.fb.array([])
  });

  get appsettings(): FormArray {
    return this.profileForm.get("appsettings") as FormArray;
  }

  resetDetailFormControls() {
    this.detailForm.controls["name"].setValue("");
    this.detailForm.controls["label"].setValue("");
    this.detailForm.controls["description"].setValue("");
    //this.detailForm.controls['logo'].setValue('');
    this.detailForm.controls["standard"].setValue(false);
    this.detailForm.controls["active"].setValue(false);
    this.detailForm.controls["iconname"].setValue("");
    this.detailForm.controls["baseurl"].setValue("");
    this.detailForm.controls["sinceversionseq"].setValue(0);
    this.detailForm.controls["deprecatedversionseq"].setValue(0);
    this.detailForm.controls["sortorder"].setValue(0);
    this.detailForm.controls["core"].setValue(false);
  }

  resetProfileFormControls() {
    const appset = this.profileForm.controls.appsettings as FormArray;
    appset.clear();
  }

  /*detailForm: FormGroup = new FormGroup({
    label: new FormControl(""),
    description: new FormControl(""),
    logo: new FormControl(""),
    standard: new FormControl(false),
    active: new FormControl(false),
  });
*/
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private dataService: DataService,
    private applicationviewService: ApplicationViewService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.applicationId = this.route.snapshot.params.id;
      this.appName = this.route.snapshot.params.appname;
    });

    this.getApplicationById();

    this.getAppSettings().subscribe((res) => {
      //console.log("response",res);
    });
  }

  appList() {
    this.router.navigateByUrl("home/applist");
  }

  editApp() {
    this.router.navigateByUrl(
      "/home/application/edit/" + this.applicationId + "/" + this.appName
    );
  }

  getApplicationById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),

      data: {
        application: {
          id: this.applicationId
        }
      }
    };

    this.isLoading = true;
    this.dataService.getApplicationById(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.application = res.data.application;
          if (this.application != null) {
            this.detailForm.controls["name"].setValue(this.application.name);
            this.detailForm.controls["label"].setValue(this.application.label);
            this.detailForm.controls["description"].setValue(
              this.application.description
            );
            //this.detailForm.controls['logo'].setValue(this.application.logo);
            this.detailForm.controls["standard"].setValue(
              this.application.standard
            );
            this.detailForm.controls["active"].setValue(
              this.application.active
            );
            this.detailForm.controls["iconname"].setValue(
              this.application.iconname
            );
            this.detailForm.controls["baseurl"].setValue(
              this.application.baseurl
            );
            this.detailForm.controls["sinceversionseq"].setValue(
              this.application.sinceversionseq != null
                ? this.application.sinceversionseq
                : 0
            );
            this.detailForm.controls["deprecatedversionseq"].setValue(
              this.application.deprecatedversionseq != null
                ? this.application.deprecatedversionseq
                : 0
            );
            this.detailForm.controls["sortorder"].setValue(
              this.application.sortorder
            );
            this.detailForm.controls["core"].setValue(this.application.core);
          }
          this.isLoading = false;
        } else {
          console.log("No data");
          this.isLoading = false;
          this.resetDetailFormControls();
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        this.resetDetailFormControls();
      }
    );
  }

  getAppSettings(): Observable<boolean> {
    var subject = new Subject<boolean>();
    subject.next(true);

    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        appsettings: {
          appname: this.appName
        }
      }
    };
    console.log(postOption);
    this.isLoading = true;
    this.dataService.getAppSettingsByName(postOption).subscribe(
      (res) => {
        console.log(res);
        if (res.success == 1) {
          this.appSettingsJSON = res.data.appsettings;
          if (this.appSettingsJSON != null) {
            //transform json to form controls
            for (let i = 0; i < this.appSettingsJSON.length; i++) {
              var item = this.appSettingsJSON[i];

              var fg = new FormGroup({
                id: new FormControl(item.id),
                organizationid: new FormControl(item.organizationid),
                profileid: new FormControl(item.profileid),
                profilename: new FormControl(item.profilename),
                applicationname: new FormControl(item.applicationname),
                accessgranted: new FormControl(item.accessgranted),
                defaultapp: new FormControl(item.defaultapp),
                active: new FormControl(item.active)
              });

              this.fgsArray.push(fg);
            }

            this.profileForm.setControl(
              "appsettings",
              new FormArray(this.fgsArray)
            );
          }
          this.isLoading = false;
        } else {
          console.log("No data");
          this.errorMessage = res.message;
          this.isError = true;
          this.isLoading = false;
          this.resetProfileFormControls();
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        this.resetProfileFormControls();
      }
    );

    return subject.asObservable();
  }
}
